module.exports = __webpack_public_path__ + "img/workspace-onboarding/edit-together-163e2a0e9600803ec43a7a1b4f8e7589.png";